import { instance } from "..";

// Public partner branding for /partner/:slug/:gamecode pages.
// Served by the pro backend; 404 when the slug is unknown or inactive.
export const getPartnerBySlug = async (slug) => {
  const { data } = await instance.get(`/api/web/partner/${slug}`);
  return data;
};
